export const AI_SEARCH_SERVICE = {
    cast: 'cast',
    clientType: 'web',
    engineId: 'engineId',
    clientId: 'clientId',
    vertexDirectEnabled: 'vertexDirectEnabled',
    guest: 'guest',
    prompt: 'prompt',
    rephrase: 'rephrase',
    filter: 'filter',
    decayConfig: 'decayConfig',
    summaryDisabled: 'summaryDisabled',
    userType: 'userType',
    swid: 'swid',
    coords: 'coords',
    selectedLocation: 'selectedLocation',
    useCoords: 'useCoords',
    locations: 'locations',
    searchType: {
        conversation: 'CONVERSATION_SEARCH',
        vertexDirect: 'VERTEX_DIRECT_SEARCH'
    }
};
